import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://fcmxcksnpg.execute-api.us-east-1.amazonaws.com';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const loginAdmin = async (email, password) => {
  const res = await api.post('/api/auth/login', { email, password });
  if (res.data.success) {
    localStorage.setItem('adminToken', res.data.data.token);
    localStorage.setItem('adminUser', JSON.stringify(res.data.data.rep));
  }
  return res.data;
};

export const logoutAdmin = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
};

export const getAdminUser = () => {
  const data = localStorage.getItem('adminUser');
  return data ? JSON.parse(data) : null;
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('adminToken');
};

// Reps
export const fetchAllReps = async (params = {}) => {
  const res = await api.get('/api/reps', { params });
  return res.data;
};

// Rep Data (visits, GPS, metrics)
export const fetchRepData = async (repId, params = {}) => {
  const res = await api.get('/api/reps/data', { params: { repId, ...params } });
  return res.data;
};

// Metrics
export const fetchMetrics = async (params = {}) => {
  const res = await api.get('/api/metrics', { params });
  return res.data;
};

// Notifications
export const sendNotification = async (data) => {
  const res = await api.post('/api/notifications/send', data);
  return res.data;
};

// Admin Rep Management
export const createRep = async (payload) => {
  const res = await api.post('/api/admin/reps', payload);
  return res.data;
};

export const updateRepStatus = async (repId, status) => {
  const res = await api.put(`/api/admin/reps/${repId}/status`, { status });
  return res.data;
};

export const updateRepSalary = async (repId, salaryAgreed) => {
  const res = await api.put(`/api/admin/reps/${repId}/salary`, { salaryAgreed });
  return res.data;
};

export const uploadRepPhoto = async (repId, imageBase64, mimeType) => {
  const res = await api.post(`/api/admin/reps/${repId}/photo`, { imageBase64, mimeType });
  return res.data;
};

export const addRepNote = async (repId, note) => {
  const res = await api.post(`/api/admin/reps/${repId}/notes`, { note });
  return res.data;
};

export const addMonthlyExpense = async (repId, payload) => {
  const res = await api.post(`/api/admin/reps/${repId}/expenses`, payload);
  return res.data;
};

export const fetchRepProfile = async (repId) => {
  const res = await api.get(`/api/admin/reps/${repId}/profile`);
  return res.data;
};

// Hospitals
export const fetchHospitals = async () => {
  const res = await api.get('/api/admin/hospitals');
  return res.data;
};

export const createHospital = async (payload) => {
  const res = await api.post('/api/admin/hospitals', payload);
  return res.data;
};

// Planned Visits
export const fetchPlannedVisits = async (params = {}) => {
  const res = await api.get('/api/admin/planned-visits', { params });
  return res.data;
};

export const assignPlannedVisits = async (payload) => {
  const res = await api.post('/api/admin/planned-visits', payload);
  return res.data;
};

// Notifications (v2)
export const createNotification = async (payload) => {
  const res = await api.post('/api/notifications', payload);
  return res.data;
};

// MFA
export const setupMfa = async (email) => {
  const res = await api.post('/api/admin/mfa/setup', { email });
  return res.data;
};

export const verifyAndEnableMfa = async (email, token) => {
  const res = await api.post('/api/admin/mfa/enable', { email, token });
  return res.data;
};

export const verifyMfaToken = async (email, token) => {
  const res = await api.post('/api/auth/verifyMfa', { email, token });
  return res.data;
};

export default api;
